import {Controller} from "@/controllers/Controller";

/**
 * Controller for supplier API (ms-purchase)
 */
export class SupplierController extends Controller {

    static getAll(urlParams = "") {
        return this.requestBuilder("GET", `/purchase/suppliers${urlParams}`, true);
    }

    // Totaux (achats, payé, reste à payer, en retard) de chaque fournisseur
    static getSummary() {
        return this.requestBuilder("GET", `/purchase/suppliers/summary`, true);
    }

    static get(id) {
        return this.requestBuilder("GET", `/purchase/suppliers/${id}`, true);
    }

    static post(body) {
        return this.requestBuilder("POST", `/purchase/suppliers`, true, body);
    }

    static patch(id, body) {
        return this.requestBuilder("PATCH", `/purchase/suppliers/${id}`, true, body);
    }

    static delete(id) {
        return this.requestBuilder("PATCH", `/purchase/suppliers/deactivate/${id}`, true);
    }
}
